(() => {
  // === CONFIG ===
  const DISCOUNT_CODE = 'SIXSTEP'; // <-- поставь свой код скидки
  const REQUIRED_STEPS = ['1', '2', '3', '4', '5', '6'];

  let timer = null;

  function parsePipeSteps(str) {
    return new Set((str || '').split('|').filter(Boolean));
  }

  function parseCodes(str) {
    return (str || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }

  function uniq(arr) {
    const seen = new Set();
    return arr.filter(x => {
      const k = x.toLowerCase();
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }

  async function setCartDiscountCodes(codesCsv) {
    const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codesCsv })
    });

    if (!res.ok) throw new Error('Failed to update cart discounts');
    return res.json();
  }

  async function evaluate() {
    const el = document.getElementById('SixStepCartState');
    if (!el) return;

    const present = parsePipeSteps(el.dataset.present);
    const existingCodes = parseCodes(el.dataset.discountCodes);

    const hasAll = REQUIRED_STEPS.every(s => present.has(s));
    const hasOur = existingCodes.some(c => c.toLowerCase() === DISCOUNT_CODE.toLowerCase());

    // Apply
    if (hasAll && !hasOur) {
      const nextCodes = uniq([...existingCodes, DISCOUNT_CODE]).join(',');
      try { await setCartDiscountCodes(nextCodes); } catch (e) { console.warn(e); }
      return;
    }

    // Remove only OUR code (keep others)
    if (!hasAll && hasOur) {
      const nextCodes = existingCodes
        .filter(c => c.toLowerCase() !== DISCOUNT_CODE.toLowerCase())
        .join(',');
      try { await setCartDiscountCodes(nextCodes); } catch (e) { console.warn(e); }
    }
  }

  function scheduleEvaluate() {
    clearTimeout(timer);
    timer = setTimeout(evaluate, 150);
  }

  document.addEventListener('DOMContentLoaded', scheduleEvaluate);

  // Cart sections often re-render via AJAX → следим за DOM
  const obs = new MutationObserver(scheduleEvaluate);
  obs.observe(document.body, { childList: true, subtree: true });
})();
